var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-input-component",on:{"click":_vm.handleDownload}},[_c('img',{attrs:{"src":require("@/assets/images/my_comment_gray.png")}}),_c('span',[_vm._v("说点什么吧~")])])}
var staticRenderFns = []

export { render, staticRenderFns }